import React from "react";
import { createBrowserRouter, Navigate, Outlet, useNavigate } from "react-router-dom";
import ExemplePage from "../../modules/exemple/page/ExemplePage";
import PTNetworkErrorPage from "../components/ui/PTNetworkErrorPage";
import PTNotFoundErrorPage from "../components/ui/PTNotFoundErrorPage";
import PTServeurErrorPage from "../components/ui/PTServeurErrorPage";
import {
  EXEMPLE_PAGE_ROUTE,
  NETWORK_ERROR_PAGE_ROUTE,
  NOT_FOUND_ERROR_PAGE_ROUTE,
  SERVER_ERROR_PAGE_ROUTE,
} from "../constants/routerConstants";
import { AxiosInterceptor } from "../components/general/AxiosInterceptor";
import LandingPage from "../../modules/exemple/page/LandingPage";

const ErrorPageContainer = ({ children }) => {
  const navigate = useNavigate();
  const retourHandler = () => {
    navigate(-1);
  };
  return React.cloneElement(children, {
    onRetour: retourHandler,
  });
};

const AppMainContainer = () => {
  
  return (
      <div
        // style={{
        //   marginTop: "10px",
        //   marginLeft: "20px",
        //   width: "calc(100% - 30px)",
        // }}
      >
        <AxiosInterceptor>
          <Outlet />
        </AxiosInterceptor>
      </div>
  );
};

export const publicRouter = createBrowserRouter([
  { path: "*", element: <Navigate to={NOT_FOUND_ERROR_PAGE_ROUTE} replace /> },
  {
    path: "/",
    element: <AppMainContainer />,
    children: [
      // Routes de bases
      {
        path: "",
        element: <LandingPage />, // Render LandingPage when user visits `/`
        exact: true,
      },
      {
        path: SERVER_ERROR_PAGE_ROUTE,
        element: (
          <ErrorPageContainer>
            <PTServeurErrorPage />
          </ErrorPageContainer>
        ),
        exact: true,
      },
      {
        path: NOT_FOUND_ERROR_PAGE_ROUTE,
        element: (
          <ErrorPageContainer>
            <PTNotFoundErrorPage />
          </ErrorPageContainer>
        ),
        exact: true,
      },
      {
        path: NETWORK_ERROR_PAGE_ROUTE,
        element: (
          <ErrorPageContainer>
            <PTNetworkErrorPage />
          </ErrorPageContainer>
        ),
        exact: true,
      },
      // Custom Routes
      {
        path: EXEMPLE_PAGE_ROUTE,
        element: <ExemplePage />,
        exact: true,
      },
    ],
  },
]);

export default publicRouter;
